import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ─── Fix crash con el traductor automático del navegador (Google Translate) ──────
// El traductor reemplaza los nodos de texto del DOM por etiquetas <font>. Cuando React
// reconcilia (insertBefore / removeChild) un nodo que el traductor ya movió, lanza una
// excepción no capturada que desmonta toda la app y deja la pantalla en blanco.
// Blindamos esas dos operaciones para que no tiren cuando el nodo dejó de ser hijo de
// su padre: el render se recupera solo en el siguiente ciclo.
// Ref: https://github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (typeof console !== 'undefined') {
        console.warn('Se evitó un removeChild sobre un nodo movido por el traductor del navegador.', child);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== 'undefined') {
        console.warn('Se evitó un insertBefore con un nodo de referencia movido por el traductor del navegador.', referenceNode);
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 